import { useState } from "react"
import { DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Button } from "@/components/ui/button"
import { IconCircleCheck, IconHash, IconLetterT , IconLink, IconBraces} from "@tabler/icons-react"

interface ColumnDialogProps {
  onSubmit: (data: { name: string; type: string }) => void;
}

export function AddKnowColumn({ onSubmit }: ColumnDialogProps) {
  const [name, setName] = useState("");
  const [type, setType] = useState(""); 

  const handleSubmit = () => {
    onSubmit({ name, type });
  };

  const handleTypeSelect = (selectedType: string) => {
    setType(selectedType);
  };

  return (
    <DialogContent className="p-4">
      <div>
        <div className="mb-4">
          <h1 className="text-lg font-semibold pb-3">Column Name</h1>
          <Input
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="col-span-3"
            placeholder="Enter column name"
          />
        </div>
        <div className="mb-4">
          <h1 className="text-lg font-semibold py-2">Column Type</h1>

          <div className="grid grid-cols-2 gap-4">
            <Button
              type="button"
              variant={type === "Text" ? "default" : "outline"} // Highlight the selected button
              className="text-slate-700 justify-start"
              onClick={() => handleTypeSelect("Text")}
            >
              <IconLetterT size={16} className="mr-2" color="blue" /> Text
            </Button>
            <Button
              type="button"
              variant={type === "Number" ? "default" : "outline"}
              className="text-slate-700 justify-start"
              onClick={() => handleTypeSelect("Number")}
            >
              <IconHash size={16} className="mr-2" color="blue" /> Number
            </Button>
            <Button
              type="button"
              variant={type === "Checkbox" ? "default" : "outline"}
              className="text-slate-700 justify-start"
              onClick={() => handleTypeSelect("Checkbox")}
            >
              <IconCircleCheck size={16} className="mr-2" color="blue" /> Checkbox
            </Button>
            <Button
              type="button"
              variant={type === "Link" ? "default" : "outline"}
              className="text-slate-700 justify-start"
              onClick={() => handleTypeSelect("Link")}
            >
              <IconLink size={16} className="mr-2" color="blue" /> Link
            </Button>
            <Button
              type="button"
              variant={type === "JSON" ? "default" : "outline"}
              className="text-slate-700 justify-start"
              onClick={() => handleTypeSelect("JSON")}
            >
              <IconBraces size={16} className="mr-2" color="blue" /> JSON
            </Button>
          </div>
        </div>
      </div>
      <DialogFooter>
      <Button 
        variant={(!name || !type) ? "outline" : "default"}
        type="button" 
        onClick={handleSubmit}
        disabled={!name || !type} // disable if either name or type is empty
      >
        Add Column
      </Button>
      </DialogFooter>
    </DialogContent>
  );
}